import 'custom-event-polyfill';

// import external dependencies
const jQuery = require('jquery');

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_vue.js';

// import local dependencies
import Router from './utils/Router';

// Each route represents a wordpress page,
// e.g. if page name is 'contact us', route should be named 'contactUs'
import home from './routes/home';
import about from './routes/about';
import awards from './routes/awards';
import awards2 from './routes/awards2';
import common from './routes/common';
import publications from './routes/publications';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // Home page
    home,
    // About page
    about,
    // Awards page
    awards,
    // Awards 2 page
    awards2,
    // All pages
    common,

    publications
});

window.finalize = 0;

// Load Events
jQuery($ => routes.loadEvents($));
